import { G2ReviewDialogComponent } from '@Common/Dialogs/components/G2ReviewDialog/g2-review-dialog.component';
import { ResearchRequestDialogComponent } from '@Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';
import { NavItemType, NavItem } from '@Common/Layout/components/Navbar/navbar.component';
import { userPermissionsEnum } from '@Core/Users/enums/user-permissions.enum';


export const refmediaSupportNav: NavItem[] = [
    {
        label: 'Core.navigation.support.supportAndTraining',
        icon: 'fa-duotone fa-regular fa-headset',
        id: 'primaryNavSupport',
        collapsed: true,
        items: [
            {
                label: 'Core.navigation.support.contactSupport',
                url: 'mailto:support@refmedia.ca',
                id: 'primaryNavContactUs'
            },
            {
                label: 'Core.navigation.support.supportLibrary',
                url: 'https://www.agilitypr.com/support/',
                id: 'primaryNavSupportLibrary'
            },
            {
                label: 'Core.navigation.support.submitRequest',
                type: NavItemType.dialog,
                permissions: [
                    userPermissionsEnum.targeting,
                    userPermissionsEnum.advancedTargeting
                ],
                dialogReference: ResearchRequestDialogComponent,
                id: 'primaryNavSubmitResearchRequest',
            }
        ]
    }
];
